import React, { Component } from 'react';
// import moment_lib from 'moment';
// import { message as antd_message, Modal as antd_Modal } from 'antd';
// import { FetchHelper as fh } from "freesia-core";
// import { getRandomColor } from "../../../../framework/color/predefine-color";
// import { parseResultToJson as parseResultToJsonHelper } from '../../../../../utils/helper';
import _loadjs from '../utils/loadjs';

// import Accessor from "../../../maps/cesium/core/utils/Accessor";

import DiagramUtils from "../utils/DiagramUtils";
// import _sm4 from '../utils/sm4';

export default class DiagramUI extends Component {

    state = {};

    listeners = [];

    constructor(props, context) {
        super(props, context);
    }

    update() {
        this.setState({});
    }

    componentWillMount() {
        this.props.model._sys.ui = this;
        this.props.model.dataSources.forEach(c => {
            c._sys.__uiReady = true;
            // c._sys.__runScript = this.runScript.bind(this);
            // c._sys.__runActions = this.runActions.bind(this);
        });
        this.props.model.messages.forEach(c => {
            c._sys.__designer = this.props.model._sys.designer;
            // c._sys.__runActions = this.runActions.bind(this);
            c.on();
        });
        this.props.model.events.forEach(c => {
            c._sys.__designer = this.props.model._sys.designer;
            // c._sys.__model = this.props.model;
            // c._sys.__runActions = this.runActions.bind(this);
        });

        this.runScript(this.props.model.scripts.scriptBeforeMount);

        this.unregisterPropertyChangedListener = this.props.model.registerPropertyChangedListener((name, valOld, valNew, subName) => {
            // console.log(`${this.props.model.getType()}, ${name}, ${subName}                 ${valOld} ---> ${valNew}`);
            this.onModelChanged && this.onModelChanged(name, valOld, valNew, subName);
            this.onModelChange && this.onModelChange(name, valOld, valNew, subName);
            this.onPropertyValueChanged(name, valOld, valNew, subName);
        })

        this.props.model.dataSources.forEach(c => c.refreshInner());
    }

    componentDidMount() {

        let m = this.props.model;
        if (m.name)
            m._sys.designer.registerNamedDiagram(m.id, this, m);

        setTimeout(() => {
            this.runScript(this.props.model.scripts.scriptAfterMount);
        }, 0);
    }

    componentWillUnmount() {
        this.props.model.dataSources.forEach(c => { c._sys.__uiReady = false; });
        this.props.model.messages.forEach(c => { c.off(); });
        this.runScript(this.props.model.scripts.scriptBeforeUnmount);
        this.unregisterPropertyChangedListener();
        this.listeners.forEach(c => c());

        let m = this.props.model;
        m._sys.designer.unregisterNamedDiagram(m.id);
    }

    componentWillReceiveProps(props) {
        this.runScript(this.props.model.scripts.scriptAfterPropsReceived, undefined, props.model);
    }

    onPropertyValueChanged(name, valOld, valNew, subName) {

    }

    activeEvent(name, args) {
        if (!name)
            return;

        let m = this.props.model;
        m.events.forEach(c => {
            if (c.name === name)
                c.run(args, {
                    model: m,
                    designer: m._sys.designer,
                    runScript: this.runScript.bind(this),
                });
        });
    }

    runActions(actions, data) {
        return this.props.model.runActions(actions, data);
    }

    runScript(script, customDataContext, customModel, args, opts) {
        return this.props.model.runScript(script, customDataContext, customModel, args, opts);
    }

    listenDataChanged(name, listener) {
        let un = this.props.model._sys.designer.registerDataChangedListener(name, obj => {
            listener && listener(obj);
        });

        this.listeners.push(un);
    }

    createModel(type) {
        return DiagramUtils.createModel(type);
    }

    createModelByTemplate(id) {
        return DiagramUtils.createModelByTemplate(this.props.model._sys.designer, id);
    }
}
